module.exports = __webpack_public_path__ + "static/media/arrow-to-top.2f6db6b0.svg";